import React from 'react';
import { View, ViewStyle } from 'react-native';

interface CenteredContentWrapperProps {
  maxWidth?: number;
  paddingHorizontal?: number;
  style?: ViewStyle | ViewStyle[];
  children: React.ReactNode;
}

// Centers children and constrains inner width on wide screens, while remaining fluid on small screens.
const CenteredContentWrapper: React.FC<CenteredContentWrapperProps> = ({
  maxWidth = 600,
  paddingHorizontal = 24,
  style,
  children,
}) => {
  return (
    <View style={{ width: '100%', alignItems: 'center' }}>
      <View style={[{ width: '100%', maxWidth, paddingHorizontal }, Array.isArray(style) ? style : [style]]}>
        {children}
      </View>
    </View>
  );
};

export default CenteredContentWrapper;
